import styled from 'styled-components';
import { theme } from '../../../../styles/theme';

export const ToolbarContainer = styled.div`
  display: flex;
  padding: 24px;
  column-gap: 16px;
`;

export const Label = styled.div`
  min-width: 200px;
  font-size: 20px;
  font-weight: 600;
  line-height: normal;
  color: ${theme.colors.secondary900};
`;
